import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./style.scss";

interface FilePreviewerProps {
  file: File | null;
}

const getFileExtension = (url: string) =>
  url.split(".").pop()?.toLowerCase() || "";

const InstanceFilePreviewer: React.FC<FilePreviewerProps> = ({ file }) => {
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file);
      setFileUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setFileUrl(null);
  }, [file]);

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const handlePreview = () => setIsModalOpen(true);

  if (!file || !fileUrl) return null;

  const fileExtension = getFileExtension(file.name);
  const isImage = ["png", "jpg", "jpeg"].includes(fileExtension);

  if (!isImage) return null;

  return (
    <>
      <div>
        <span className="file-name-link" onClick={handlePreview}>
          {file.name}
        </span>
      </div>

      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Image Preview</ModalHeader>
        <ModalBody className="d-flex justify-content-center">
          <img src={fileUrl} alt="Preview" />
        </ModalBody>
      </Modal>
    </>
  );
};

export default InstanceFilePreviewer;
